import { Input, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { PopUpBusyComponent } from '../Components/PopUps/PopUpBusyComponent';
import { AppInjector } from './AppInjector';
import { DialogService } from './DialogService';

export abstract class BaseBusyableComponent implements OnDestroy {

	protected obsToCloseSubject = new Subject();

	private busymodalService: NgbModal
	protected dialogService: DialogService;

	public downloadtoken: string = '';
	constructor() {
		this.busymodalService = AppInjector.get(NgbModal);
		this.dialogService = AppInjector.get(DialogService);
	}

	makeNameUnique() : string {
		return Math.random().toString().replace('.', '');
	}
	ngOnDestroy(): boolean {
		this.busymodalService = null;;
		this.dialogService = null;
		this.hideBusyModal();

		this.obsToCloseSubject.next(null);
		this.obsToCloseSubject.complete();

		return true;
	}

	addressToLatLngEvenInvalid(addr: TooBig4Car.Logic.Address): google.maps.LatLngLiteral {
		if (!addr || !addr.Latitude || !addr.Longitude) {
			return null;
		}
		var point: google.maps.LatLngLiteral = {
			lat: addr.Latitude,
			lng: addr.Longitude
		};
		return point;
	}

	addressToLatLng(addr: TooBig4Car.Logic.Address): google.maps.LatLngLiteral {
		if (!addr || addr.IsLatLongInvalid) {
			return null;
		}
		return this.addressToLatLngEvenInvalid(addr);
	}

	public hasBaseDropZoneOver = false;
	public fileOverBase(e: any): void {
		this.hasBaseDropZoneOver = e;
	}

	fixPdfButtons() {
		if (document) {
			Array.from(document.querySelectorAll('ngx-extended-pdf-viewer button')).forEach(elem => {
				elem.setAttribute('type', 'button');
			});
		}
	}

	protected getSavedSetting(settingName: string, pageName: string) {
		var storeName = (pageName || '') + (settingName || '');
		if (storeName) {
			var savedData = localStorage.getItem(storeName);
			if (savedData) {
				return JSON.parse(savedData);
			}
		}
		return null;
		
	}

	protected setSavedSetting(settingName: string, pageName: string, obj: any) {
		var storeName = (pageName || '') + (settingName || '');
		localStorage.setItem(storeName, JSON.stringify(obj));
	}

	goBack() {
		window.history.back();
	}

	onSort(newCriteria: TooBig4Car.Logic.SortCriteria) {
		this.sortCriteria = newCriteria;
	}

	@Input()
	sortCriteria: TooBig4Car.Logic.SortCriteria;

	private _isSaving: boolean = false;

	private timer: any = null;

	get isSaving(): boolean {
		return this._isSaving;
	}

	set isSaving(val: boolean) {
		if (this._isSaving != val) {
			this._isSaving = val;
			if (val) {
				this.startBusyTimer();
			} else {
				
				this.hideBusyModal();
			}
		}
	}

	cancelBusyOperation() {
		this.hideBusyModal();
	}
	private busymodal: NgbModalRef = null;
	startBusyTimer() {
		var thisHolder = this;
		thisHolder.timer = setTimeout(function () {
			thisHolder.busymodal = thisHolder.busymodalService.open(PopUpBusyComponent);
			thisHolder.busymodal.result.then((result: boolean) => {
				if (result) {
					thisHolder.cancelBusyOperation();
				}
			}, (reason) => {

			});
		}, 1000);
	}
	hideBusyModal() {
		clearTimeout(this.timer);
		if (this.busymodal) {
			this.busymodal.close();
		}
	}

	getErrorsFromResponse(error: any): string[] {
		var errors = [];
		if (error.error) {
			error = error.error;
		}
		var any = false;
		if (error) {
			if (error.errors) {
				error = error.errors;
			}
			if (typeof(error) != "string") {
				for (var key in error) {
					if (error.hasOwnProperty(key)) {
						errors.push(error[key][0]);//list of error messages in an array
						any = true;
					}
				}
			} else {
				errors.push(error);
			}
		}
		if (!any) {
			errors.push('Error');
		}
		return errors;
	}
}
